package com.vizio.redwolf.utils

data class ConsentV2FusedEnvironmentConfig(val environmentGroup: EnvironmentGroup, val apiKey: String)